export const CONTACT_TYPE_MAIL = 'MAIL';
export const CONTACT_TYPE_PHONE = 'PHONE';

export default { CONTACT_TYPE_MAIL, CONTACT_TYPE_PHONE };


// WEBPACK FOOTER //
// ./src/defaults/ContactTypes.js